import {
  Button,
  Checkbox,
  Classes,
  Dialog,
  FormGroup,
  InputGroup,
} from "@blueprintjs/core";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { IViewModel } from "mobx-utils";
import * as React from "react";
import { api, apiOperacao } from "../../api";
import { IUsuario } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { toast } from "react-toastify";
import { formatCnpj, PERMISSOES, toast_error } from "../../utils";
import { BootstrapTable, SearchField, TableHeaderColumn} from "react-bootstrap-table";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { PerfilStore } from "../../stores/perfil/PerfilStore";

interface CreateUserDialogProps {
  onClose: () => void;
}

interface CreateUserDialogState {
  conta_id: any;
  listEmpresas: any[];
}

@observer
export class CreateUserDialog
  extends React.Component<CreateUserDialogProps, CreateUserDialogState>
{

  obs = observable({
    usuario: null as IUsuario & IViewModel<IUsuario>,
    focusDone: false as boolean,
    currentPassword: "" as string,
    newPassword: "" as string,
    working: false as boolean,
    conta_id: [] as any,
    nome_completo: "" as string,
    email: "" as string,
    senha: "" as string,
    list: [] as String[],
    permissoes: {},
  })

  constructor(props: CreateUserDialogProps) {
    super(props);

    this.state = {
      conta_id: "",
      listEmpresas: []
    }
  }

  async componentDidMount() {

    this.setState({ listEmpresas: [], conta_id: AppStore.obs1.contaId });
    
    this.obs.permissoes = {}

  }

  refresh = () => {
    window.location.reload();
  };

  handleCreateUser = async () => {
    
    let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

    if (!this.obs.nome_completo) {
      toast.error('Preencha o nome do usuário', {});
      return;
    }
    if (!this.obs.email) {
      toast.error('Preencha o email do usuário', {});
      return;
    }
    if (!regex.test(this.obs.email)) {
      toast.warning("E-mail inválido!", {});
      return
    }
    if (!this.obs.senha) {
      toast.error('Preencha a senha do usuário', {});
      return;
    }

    if (this.obs.senha.match(/\d/) == null || this.obs.senha.match(/[a-z]/i) == null) {
      toast.error('A senha deve conter números e letras', {});
      return;
    }

    if (this.obs.senha.length < 8) {
      toast.error('A senha deve conter 8 caracter', {});
      return;
    }

    try {
      let params = {
        nome_completo: this.obs.nome_completo,
        email: this.obs.email,
        senha: this.obs.senha,
        permissoes: this.obs.permissoes,
        filiais: this.state.listEmpresas,
      }

      let resp = await apiOperacao("user_permissions").post(`/user_permissions/add-usuario-conta`, params)

      if (resp.data.ok) {
        this.props.onClose();
        toast.success('Usuário criado com sucesso', {});

        await PerfilStore.usuariosConta()

      } else {
        toast.error(resp.data.msg, {});
      }
    } catch (ex) {
      toast_error(ex, `Erro ao criar um Usuário, tente novamente mais tarde.`);
    }
  }

  handleCheckEmpresaChange = async (row, checked) => {

    if (checked) {

      this.setState(state => { state.listEmpresas.push(row.cnpj) });

    } else {

      let index = this.state.listEmpresas.indexOf(row.cnpj);

      this.state.listEmpresas.splice(index, 1);

    }

  };

  handleCheckEmpresas = async (check, row) => {

    if (check) {

      this.setState({ listEmpresas: row?.map(value => value.cnpj) });

    } else {

      this.setState({ listEmpresas: [] });
    }

  };

  createCustomSearchFieldSol = (props) => {
    return (
      <SearchField
        className="input-filter input-filter-sefa input-filter-empresa-user"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Razão Social, CNPJ)"
      />
    );
  };

  render() {

    const options_soli = {
      searchField: this.createCustomSearchFieldSol,
    };

    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleCheckEmpresaChange,
      onSelectAll: this.handleCheckEmpresas,
      selected: this.state.listEmpresas,
    };

    let empresasUser = EmpresaStore.sortedEmpresasPermissions?.map(emp => {

      return ({
        _id: emp._id,
        razao_social: emp.razao_social,
        cnpj: emp.cnpj,
        cnpj_formated: formatCnpj(emp.cnpj)
      })

    });

    return (
      <Dialog isOpen className="AlertUser AlertPermission" onClose={this.props.onClose}>
        <h2 className="titleSEFAZ" style={{marginBottom: 5}}>Adicionar Usuário</h2>
        <p style={{ color: "rgba(255, 0, 0, 0.82)" }}>
          <b>Observação:</b> Após alterar as permissões do usuário, é necessário que ele faça login novamente no sistema para que as alterações sejam aplicadas.
        </p>
          <div style={{ display: "flex", gap: 5 }}>
            <FormGroup label="Nome Completo" labelInfo="*" style={{ width: "33%" }}>
              <InputGroup
                onChange={(e: any) =>
                  this.obs.nome_completo = e.target.value}
              />
            </FormGroup>

            <FormGroup label="E-mail para Acesso" labelInfo="*" style={{ width: "33%" }}>
              <InputGroup
                name='new-email'
                autoComplete='new-email'
                placeholder="email@email.com"
                onChange={(e: any) => this.obs.email = e.target.value}
              />
            </FormGroup>

            <FormGroup label="Senha" labelInfo="*" style={{ width: "33%" }}>
              <InputGroup
                type="password"
                name='new-password'
                autoComplete='new-password'
                placeholder="********"
                onChange={(e: any) => this.obs.senha = e.target.value}
              />
            </FormGroup>
          </div>

        <FormGroup label="Selecione as permissões para esse usuário:" labelFor="empresas">
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 15, }}>
            {PERMISSOES.map(item => (
              <div style={{ width: 180 }}>
                <Checkbox
                  key={item.id}
                  type="checkbox"
                  label={item.label}
                  style={{ marginTop: 0, marginBottom: 0, width: "max-content" }}
                  checked={!!this.obs.permissoes[item.id]}
                  onChange={(e: any) => this.obs.permissoes = ({ ...this.obs.permissoes, [item.id]: e.target.checked })}
                />
              </div>
            ))}
          </div>
        </FormGroup>

        <FormGroup label="Selecione as Empresas" labelFor="empresas">
          <div className="select-empresa-sefa select-empresa-user">
            <BootstrapTable data={empresasUser} selectRow={selectRowProp} options={options_soli} search>
              <TableHeaderColumn dataField="cnpj" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="razao_social" width="75%">Razão Social</TableHeaderColumn>
              <TableHeaderColumn dataField="cnpj_formated" width="20%">CNPJ</TableHeaderColumn>
            </BootstrapTable>
          </div>
        </FormGroup>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              text="Cancelar"
              onClick={this.props.onClose}
              disabled={this.obs.working}
            />
            <Button
              text="Salvar"
              intent="primary"
              onClick={this.handleCreateUser}
              loading={this.obs.working}
            />
          </div>
        </div>
      </Dialog>
    );
  }
}
